import {styled} from '@mui/material/styles';
import { defaultTheme } from '../../components';

function Index({src, shadow, children}) {
    return (
        <TitleWrap>
            <TitleImg src={src} shadow={shadow}/>
            {children}
        </TitleWrap>
    )
}

export default Index

const TitleWrap = styled('div')`
    display: flex;
    justify-content: start;
    align-items: top;
    /* background-color: ${defaultTheme.card.custom.b.background}; */

    width: max-content;
    /* padding: 14px 50px 16px 16px; */
    margin: 0 0 -16px 0px;
    padding: 0px 16px;
    /* border-radius: 18px 18px 0 0;
    position: relative;
    color: white;
    overflow: hidden;
    clip-path: polygon(
        0 0,
        calc(100% - 50px) 0,
        100% 100%,
        100% 100%,
        0 100%
    ); */
`

const TitleImg = styled('img')`
    display: flex;
    width: 48px;
    height: 48px;
    margin-right: 10px;
    border-radius: 5px;
    /* border: 1px solid #ddd; */
    box-shadow: 0px 0px 5px ${p => p.shadow || '#fde400'};
    /* background: linear-gradient(135deg, #d7d7d7, #ffffff, #b3b3b3, #ffffff, #d7d7d7);
    background-size: 200% 200%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: shine 2s linear infinite;

    @keyframes shine {
        0% {
        background-position: 0% 50%;
        }
        100% {
        background-position: 100% 50%;
        }
    } */
`
